export default {"src":"/_next/static/media/Home_Bazaar.b89d560b.svg","height":80,"width":80};